// tslint:disable object-literal-key-quotes
import { Component, EventListener, findComponents, triggerPublicEvent, getComponentByDomNode } from '@gondel/core';
import '@swisslife/patterns-base/src/atoms/image/js/image';
import { Image } from '@swisslife/patterns-base/src/atoms/image/js/image';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import {
	deleteLocalStorageItem,
	localStorageValueExists,
	setLocalStorageItem,
} from '@swisslife/shared-ui/src/utils/local-storage/js/local-storage';
import { IGScrollToTargetHandlerOptions } from '@swisslife/shared-types/src/types/gondel-public-events';
import eventBus, { SLEvent } from '@swisslife/sl-event-bus/src/sl-event-bus';
import $ from 'jquery';
import '../../video/js/video';
import { Video } from '../../video/js/video';
import { Header } from '../../../organisms/header/js/header';
import { IGOverlayHandlerOptions } from '@swisslife/shared-types/src/types/gondel-public-events';

enum UiTypes {
	Image16_6 = '16-6',
	Image16_8 = '16-8',
}

enum States {
	Animate = 'state-m-mood-image--animate',
	Scroll = 'state-m-mood-image--scroll',
	CategoryIsHidden = 'state-m-mood-image--catgeory-is-hidden',
	HeadingIsHidden = 'state-m-mood-image--heading-is-hidden',
	DescriptionIsHidden = 'state-m-mood-image--description-is-hidden',
	ButtonIsHidden = 'state-m-mood-image--button-is-hidden',
	WhiteBoxIsHidden = 'state-m-mood-image--white-box-is-hidden',
	QuickLinksOpen = 'state-m-mood-image--quick-links-open',
	HideOverflow = 'state-m-mood-image--overflow-is-hidden',
	DisableAnimation = 'state-h-animation--disabled',
	IsFavorite = 'state-m-mood-image--is-favorite',
	IsHiding = 'state-m-mood-image--is-hiding',
	IsHidden = 'state-m-mood-image--is-hidden',
	ShowDescriptionOnMobile = 'state-m-mood-image--show-description-on-mobile',
}
type TStates = keyof typeof States;

enum Selectors {
	Main = '.js-l-main',
	Image = '.js-m-mood-image__image',
	ImageOverflow = '.js-m-mood-image__overflow',
	Header = '.js-o-header',
	ContentAnimation = '.js-m-mood-image__content-animation',
	Content = '.js-m-mood-image__content',
	ContentInner = '.js-m-mood-image__content-inner',
	Arrow = '.js-m-mood-image__arrow-down',
	FavoriteButton = '.js-m-mood-image__favorite-button',
	Category = '.js-m-mood-image__category .a-text',
	Heading = '.js-m-mood-image__heading .a-heading',
	Description = '.js-m-mood-image__description .a-text',
	Button = '.js-m-mood-image__button .a-button',
	ButtonText = '.js-m-mood-image__button .js-a-button__text',
	OverlayButton = '.js-m-mood-image__trigger-overlay',
}

interface IMoodImageConfiguration {
	articleId: string;
	localStorageName: string;
}

// please note: the colors coming from the backend MUST stay named colors as they cannot deliver numbers,
// we therefore map them in JS, css works for both
export const backgroundColors = {
	// old be colors -> remove with a refactoring
	white: 'white' as 'white',
	red: 'red' as 'red',
	orange: 'orange' as 'orange',
	yellow: 'yellow' as 'yellow',
	violet: 'violet' as 'violet',
	'10': '10' as '10',
	'brand-03': 'brand-03' as 'brand-03',
	'brand-05': 'brand-05' as 'brand-05',
	'brand-06': 'brand-06' as 'brand-06',
	'brand-07': 'brand-07' as 'brand-07',
};

export type TBackgroundColor = keyof typeof backgroundColors;

export interface IPayloadChangeMoodImage {
	category?: string;
	description?: string;
	heading?: string;
	button?: {
		href: string;
		text: string;
	};
	backgroundColor?: TBackgroundColor;
	showDescriptionOnMobile?: boolean | undefined;
}

export interface IPayLoadShowMoodImage {
	showDescriptionOnMobile?: boolean | undefined;
}

// Jquery animate as promise
const animate = (
	$elem: JQuery<HTMLElement>,
	properties: JQuery.PlainObject,
	durationEasing: JQuery.Duration | string
): Promise<void> => {
	return new Promise((resolve) => {
		$elem.animate(properties, durationEasing, resolve);
	});
};

@Component('MoodImage')
export class MoodImage extends GondelJqueryComponent {
	private configuration: IMoodImageConfiguration;
	private image: Image | null = null;
	private video: Video | null = null;
	private uiType: UiTypes;
	private controllers: any[] = Array();
	private height: number | undefined;
	private initialState: IPayloadChangeMoodImage;
	private header?: Header;
	private isFavorite: boolean = false;
	private tmpStateWhileHidden: IPayloadChangeMoodImage = {};

	public start() {
		const $moodImage = $(Selectors.Image, this.$ctx);
		if ($moodImage.length > 0) {
			const imageComponents = findComponents<Image>($moodImage.get(0), 'Image');
			if (imageComponents.length > 0) {
				this.image = imageComponents[0];
			}
		}

		this.configuration = {
			articleId: this.$ctx.data('article-id'),
			localStorageName: this.$ctx.data('local-storage-name'),
		};

		this.initialState = this.currentState;

		const videoComponents = findComponents<Video>(this._ctx, 'Video');
		if (videoComponents.length > 0) {
			this.video = videoComponents[0];
		}

		this.uiType = this.$ctx.data('ui-type') || UiTypes.Image16_6;
		const $header = this.$ctx.closest(Selectors.Header);
		if ($header.length > 0) {
			this.header = getComponentByDomNode<Header>($header.get(0));
		}
	}

	public async sync() {
		// check if animation should be enabled
		if (!$('body').hasClass(States.DisableAnimation)) {
			this.initializeFadeAnimation();
			await this.initializeImageAnimation();

			if (this.uiType === UiTypes.Image16_8) {
				await this.initializeContentAnimation();
			}
		}

		if (this.video !== null) {
			this.video.initVideoPlayer();
		}

		this.initializeFavoriteState();

		(async () => {
			const eb = await eventBus();
			eb.on(SLEvent.ChangeMoodImage, this.handleChangeMoodImage);
			eb.on(SLEvent.ResetMoodImage, this.handleResetMoodImage);
			eb.on(SLEvent.HideMoodImage, this.handleHideMoodImage);
			eb.on(SLEvent.ShowMoodImage, this.handleShowMoodImage);
		})();
	}

	public stop() {
		for (const controller of this.controllers) {
			controller.destroy(true);
		}
	}

	public removeWhiteBoxIsHiddenClass = () => {
		this.$ctx.removeClass(States.WhiteBoxIsHidden);
	};

	@EventListener('click', Selectors.Arrow)
	public _handleArrowClick(ev: MouseEvent) {
		ev.preventDefault();
		this.scrollToContent();
	}

	@EventListener('click', Selectors.FavoriteButton)
	public _handleFavoriteClick() {
		if (this.isFavorite) {
			deleteLocalStorageItem(this.configuration.localStorageName, this.configuration.articleId);
		} else {
			setLocalStorageItem(this.configuration.localStorageName, this.configuration.articleId);
		}
		this.isFavorite = !this.isFavorite;
		this.toggleIsFavoriteStateClass();
		this.toggleIsFavoriteAttribute();
	}

	public scrollToContent() {
		const eventOptions: IGScrollToTargetHandlerOptions = {
			target: Selectors.Main,
			duration: 500,
		};

		triggerPublicEvent('gScrollToTargetHandler', this, undefined, eventOptions);
	}

	public toggleStateClass(stateToToggle: TStates, forceState?: boolean) {
		if (forceState !== undefined) {
			this.$ctx.toggleClass(States[stateToToggle], forceState);
		} else {
			this.$ctx.toggleClass(States[stateToToggle]);
		}
	}

	public removeStateClass(stateToToggle: TStates) {
		this.$ctx.removeClass(States[stateToToggle]);
	}

	private get currentState(): IPayloadChangeMoodImage {
		return {
			category: $(Selectors.Category, this.$ctx)
				.text()
				.trim(),
			heading: $(Selectors.Heading, this.$ctx)
				.text()
				.trim(),
			description: $(Selectors.Description, this.$ctx)
				.text()
				.trim(),
			button: {
				href: (($(Selectors.Button, this.$ctx).attr('href') as string) || '').trim(),
				text: $(Selectors.ButtonText, this.$ctx)
					.text()
					.trim(),
			},
			// initial value from BE is a named color
			backgroundColor: this.backgroundColor,
			showDescriptionOnMobile: this.$ctx.hasClass(States.ShowDescriptionOnMobile),
		};
	}

	private initializeFavoriteState() {
		this.isFavorite = localStorageValueExists(this.configuration.localStorageName, this.configuration.articleId);
		this.toggleIsFavoriteStateClass();
		this.toggleIsFavoriteAttribute();
	}

	private toggleIsFavoriteStateClass() {
		this.$ctx.toggleClass(States.IsFavorite, this.isFavorite);
	}

	private toggleIsFavoriteAttribute() {
		// the data-favorized attribute is used by the AEM backend to track the favorized-state for analytics purposes.
		this.$ctx.attr('data-favorized', `${this.isFavorite}`);
	}

	private initializeFadeAnimation() {
		if (this.image !== null) {
			const promise = this.image.getImageLoadedPromise();
			promise.then(() => {
				this.toggleStateClass('Animate', true);
				this.toggleStateClassOnBreadcrumb();
			});
		} else {
			// if it's a mood with background or video, we start the animation right away
			this.toggleStateClass('Animate', true);
			this.toggleStateClassOnBreadcrumb();
		}
	}

	private toggleStateClassOnBreadcrumb() {
		if (this.header && this.header.breadcrumb) {
			this.header.breadcrumb.toggleStateClass('Animate', true);
		}
	}

	private async initializeContentAnimation() {
		const $content = this.$ctx.find(Selectors.ContentAnimation);

		// tslint:disable
		const {
			TimelineMax,
			Linear,
			ScrollMagic,
		} = (await import(/* webpackChunkName: "dynamic-imports/animation-libs" */ '@swisslife/shared-ui/src/utils/animations/js/animation-libs')) as any;
		// tslint:enable

		const controller = new ScrollMagic.Controller();
		const timelineContent = new TimelineMax();

		timelineContent.to($content, 1, { y: -400, ease: Linear.easeIn });

		const sceneContent = new ScrollMagic.Scene({
			triggerHook: 'onLeave',
			duration: '100%',
		});
		// .addIndicators() // add visual indicators to your page, to be able to see exactly when a scene is triggered

		sceneContent.setTween(timelineContent);
		controller.addScene([sceneContent]);
		this.controllers.push(controller);
	}

	private async initializeImageAnimation() {
		const $image = this.$ctx.find(Selectors.Image);

		// tslint:disable
		const {
			TimelineMax,
			Linear,
			ScrollMagic,
		} = (await import(/* webpackChunkName: "dynamic-imports/animation-libs" */ '@swisslife/shared-ui/src/utils/animations/js/animation-libs')) as any;
		// tslint:enable

		const controller = new ScrollMagic.Controller();
		const timelineImage = new TimelineMax();

		timelineImage.to($image, 1, { y: 200, ease: Linear.easeIn });
		timelineImage.eventCallback('onStart', () => {
			this.toggleStateClass('Scroll', true);
		});
		timelineImage.eventCallback('onReverseComplete', () => {
			this.toggleStateClass('Scroll', false);
		});

		const sceneImage = new ScrollMagic.Scene({
			triggerHook: 'onLeave',
			duration: '100%',
		});
		// .addIndicators() // add visual indicators to your page, to be able to see exactly when a scene is triggered

		sceneImage.setTween(timelineImage);
		controller.addScene([sceneImage]);
		this.controllers.push(controller);
	}

	private handleChangeMoodImage = async (_: string, payload: IPayloadChangeMoodImage) => {
		this.changeCategory(payload.category);
		this.changeHeading(payload.heading);
		this.changeDescription(payload.description);
		this.changeButton(payload.button);
		this.changeDescriptionOnMobile(payload.showDescriptionOnMobile);

		this.backgroundColor = payload.backgroundColor;
	};

	private changeDescriptionOnMobile = (showDescriptionOnMobile?: boolean) => {
		if (showDescriptionOnMobile) {
			this.$ctx.addClass(States.ShowDescriptionOnMobile);
			return;
		}
		this.$ctx.removeClass(States.ShowDescriptionOnMobile);
	};

	private changeButton = (button?: { text?: string; href?: string }) => {
		if (button && button.text && button.href) {
			this.$ctx.removeClass(States.ButtonIsHidden);
			$(Selectors.Button, this.$ctx)
				.show()
				.attr('href', button.href);
			$(Selectors.ButtonText, this.$ctx).text(button.text);
			return;
		}
		this.$ctx.addClass(States.ButtonIsHidden);
		$(Selectors.Button, this.$ctx)
			.removeAttr('href')
			.hide();
		$(Selectors.ButtonText, this.$ctx).text('');
	};

	private changeDescription = (value?: string) => {
		if (value && value !== '') {
			this.$ctx.removeClass(States.DescriptionIsHidden);
			$(Selectors.Description, this.$ctx).text(value);
			return;
		}
		this.$ctx.addClass(States.DescriptionIsHidden);
		$(Selectors.Description, this.$ctx).text('');
	};

	private changeHeading = (value?: string) => {
		if (value && value !== '') {
			this.$ctx.removeClass(States.HeadingIsHidden);
			$(Selectors.Heading, this.$ctx).text(value);
			return;
		}
		this.$ctx.addClass(States.HeadingIsHidden);
		$(Selectors.Heading, this.$ctx).text('');
	};

	private changeCategory = (value?: string) => {
		if (value && value !== '') {
			this.$ctx.removeClass(States.CategoryIsHidden);
			$(Selectors.Category, this.$ctx).text(value);
			return;
		}
		this.$ctx.addClass(States.CategoryIsHidden);
		$(Selectors.Category, this.$ctx).text('');
	};

	public get backgroundColor() {
		return this.$ctx.attr('data-bg-color') as TBackgroundColor;
	}

	public set backgroundColor(backgroundColor: TBackgroundColor | undefined) {
		if (!backgroundColor || (backgroundColors && Object.keys(backgroundColors).indexOf(backgroundColor) === -1)) {
			if (this.header) {
				try {
					this.header.moodImageIsBright = false;
				} catch (err) {
					// tslint:disable-next-line
				}
			}
			$(Selectors.ContentInner).appendTo(Selectors.Content);
			this.$ctx
				.removeAttr('data-bg-color')
				.removeClass(States.HideOverflow)
				.removeClass('m-mood-image--background')
				.addClass('m-mood-image--image');
			return;
		}

		$(Selectors.ContentInner).prependTo(this.$ctx);

		if (this.header) {
			try {
				this.header.moodImageIsBright = ['10', 'white'].indexOf(backgroundColor) !== -1;
			} catch (err) {
				// tslint:disable-next-line
			}
		}
		this.$ctx
			.attr('data-bg-color', backgroundColor)
			.addClass(States.HideOverflow)
			.addClass('m-mood-image--background')
			.removeClass('m-mood-image--image');
	}

	private handleResetMoodImage = (meta: string) => {
		this.handleChangeMoodImage(meta, this.initialState);
	};

	private get isHidden() {
		return this.$ctx.hasClass(States.IsHidden) || this.$ctx.hasClass(States.IsHiding);
	}

	private handleHideMoodImage = async () => {
		if (this.isHidden) {
			return;
		}
		this.tmpStateWhileHidden = this.currentState;
		this.$ctx.removeClass(States.ShowDescriptionOnMobile);
		this.$ctx.addClass(States.IsHiding);
		this.height = this.$ctx.height();
		this.$ctx.css({ height: this.height || 0 });
		await animate(
			this.$ctx,
			{
				height: 0,
			},
			300
		);
		this.$ctx.addClass(States.IsHidden);
	};

	private handleShowMoodImage = async (meta: string, payload?: IPayLoadShowMoodImage) => {
		if (!this.isHidden) {
			return;
		}

		this.handleChangeMoodImage('', {
			...this.tmpStateWhileHidden,
			showDescriptionOnMobile:
				(payload || {}).showDescriptionOnMobile || this.tmpStateWhileHidden.showDescriptionOnMobile,
		});
		this.$ctx.removeClass(States.IsHidden).addClass(States.IsHiding);
		await animate(
			this.$ctx,
			{
				height: this.height || 0,
			},
			300
		);
		this.$ctx.removeClass(States.IsHiding);
		this.$ctx.removeAttr('style');
	};

	@EventListener('click', Selectors.OverlayButton)
	private _handleButtonClick(ev: MouseEvent) {
		ev.preventDefault();

		const $target = $(ev.currentTarget!);

		const eventOptions: IGOverlayHandlerOptions = {
			overlayComponent: 'MoodImage',
			overlayTitle: $target.data('overlay-title') || '',
			overlayContentUrl: $target.data('overlay-content-url') || '',
		};

		triggerPublicEvent('gOverlayHandler', this, undefined, eventOptions);
	}
}
